import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import {Container, Grid} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import {InputRow} from "../index";
import {onChangeInput} from "../../services/utils";
import {expiryOfferOption} from "../../environment";

const useStyles = makeStyles((theme) => ({
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // backgroundColor:'orange'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: 10,
    borderRadius: 20
  },
  content: {
    padding: theme.spacing(4, 15, 5, 15),
    // backgroundColor:'gray'
  }
}));

const Label = (title) => {
  return (
    <p className='black-color mt-20 font-12 mb-0 text-uppercase'>{title}</p>

  )
}
export default function MakeOfferModal(props) {
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);
  // const {open, setOpen, state: {values, errors}, setState} = props
  const {open, setOpen, state, setState} = props
  const {values, errors} = state
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}

        open={open}
        onClose={handleClose}
        // closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          // timeout: 500,
        }}
      >
        <Fade in={open}>
          <Container component="main" maxWidth="sm" style={{paddingTop: 40}}>
            <div className={classes.paper}>
              <p className=' width-max-content float-right mouse-pointer pt-10 pr-20 font-18 error-class'
                 onClick={() => {
                   handleClose()
                 }}
              >X</p>
              <div className={classes.content}>
                <h1>Make offer/ Bid</h1>
                {Label('your offer')}
                <div className='display-flex align-items-center width-max-content mt-20'>
                  <span><b>PKR</b></span>
                  <div>
                    <InputRow
                      types={[
                        {value: values.price, error: errors.price, label: 'price'},

                      ]}
                      onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                      numOfInputPerRow={1}
                    />
                  </div>
                  <span>per item</span>
                </div>

                {Label('quantity')}
                <Grid className='qty-counter-container ml-5 mt-20 width-max-content'>
                  <button className='heading-color'
                          onClick={() => onChangeInput(values.qty == 0 ? 0 : --values.qty, "qty", state, setState)}>-
                  </button>
                  <input type={'number'} value={values.qty} min={0}/>
                  <button className='heading-color'
                          onClick={() => onChangeInput(++values.qty, "qty", state, setState)}>+
                  </button>
                </Grid>

                {Label('offer expiry')}
                <InputRow
                  types={[
                    {
                      type: 'select',
                      // value: values.priceUnit,
                      // error: errors.priceUnit,
                      // label: 'unit of measurement',
                      dropdownList: expiryOfferOption
                    },
                  ]}
                  onChangeInput={(value, key) => console.log(value)}
                  numOfInputPerRow={1}
                />

                {Label('message for the seller')}
                <div className='display-flex align-items-center mt-20'>
                  <InputRow
                    types={[
                      // {value: values.city, error: errors.city, label: 'region'},

                      {
                        label: 'message',
                        placeholder: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,',
                        multiline: true
                      },
                    ]}
                    onChangeInput={(value, key) => console.log("ds")}
                    numOfInputPerRow={1}
                  />
                </div>
                <div className='display-flex  flex-column  checkout-container mt-30 mb-20'>
                  <button
                    className=' add-cart-btn-small display-flex justify-content-center  bg-green border-none white-color text-center'
                    style={{minWidth: 220}}
                    onClick={(e) => props.makeOffer(e)}
                  > Make offer/ Bid
                  </button>
                </div>
              </div>
            </div>
          </Container>
        </Fade>
      </Modal>
    </div>
  );
}
